import { ReactNode } from "react";
import { SlBag, SlHeart, SlSocialInstagram,  } from "react-icons/sl";
import { TbMessageCircleHeart } from "react-icons/tb";
import { BiDrink } from "react-icons/bi";

import menu from '../assets/images/menu.png';


export const CallToStore = () => {
    return (
        <section className="bg-gray-200 py-6 pb-12">
            <h2 className="text-center amatic-sc-bold  text-3xl">Nossa lista de casamento</h2>
            <div className="pt-4 mx-auto gap-6 lg:flex flex-wrap justify-center">
                <Card icon={<BiDrink  />} href={menu} title="Menu"  description="Aproveita que ta no precinho" download={true} />
                <Card icon={<SlBag />} href="https://link.mercadopago.com.br/presenteleoenanda" title="Um baita presente" description="Uma lembrança do seu carinho por nós" />
                <Card icon={<TbMessageCircleHeart />} href="/message" title="Mural de recados"  description="Deixe uma mensagem que ficará para sempre aqui" />
                <Card icon={<SlSocialInstagram />} href="https://www.instagram.com/ar/1670432913735021/" title="Filtro no Instagram"  description="Não esqueça de nos marcar" />
            </div>
           
        </section>
    )
}

type Props = {
    title: string;
    description: string;
    icon?: ReactNode;
    href?: string ;
    download?: boolean;
}

const Card = ({icon, title, description, href, download = false}: Props) => {
    return (
        <a href={href} download={download ? download : undefined} target="_blank" className="flex rounded-xl flex-col justify-center pl-6 card h-36 bg-gradient-to-r from-stone-400 to-stone-300 mx-auto md:w-1/3 w-80 md:m-0 mb-3">
            <span className="text-xl">{icon}</span>
            <h4 className="text-2xl poppins-bold">{title}</h4>
            <p className="poppins-light">{description}</p>
        </a>
    )
}